<template>
	<div class="image-marker">
		<div class="image-marker__img">
			<img
				@click="handleAddMarker"
				src="https://i.pinimg.com/originals/bf/82/f6/bf82f6956a32819af48c2572243e8286.jpg"
				alt="Image to put marker on"
			/>
			<div
				:key="mi"
				class="image-marker__marker"
				:style="markerStyle(marker)"
				@click="handleDeleteMarker(marker.no)"
				v-for="(marker, mi) in markers"
			>
				<span>{{ marker.no }}</span>
			</div>
		</div>
	</div>
</template>

<script>
const localKey = "AMS-IMG-MARKERS"
export default {
	name: 'ImageMarker',
	data: () => ({
		markers: []
	}),
	created() {
		let markers = localStorage.getItem(localKey)
		if (markers) this.markers = JSON.parse(markers)
	},
	methods: {
		markerStyle({ top, left }) {
			return `
				top:${top}%;
				left:${left}%;
				transform:translate(-12px,-12px)
			`
		},
		syncToLocalStorage() {
			localStorage.setItem(localKey, JSON.stringify(this.markers))
		},
		handleDeleteMarker(no) {
			this.markers = this.markers.filter(m => m.no !== no)
			this.syncToLocalStorage()
		},
		handleAddMarker(e) {
			let rect = e.target.getBoundingClientRect();

			// Calculating left and top in percentange
			let top = Math.round(((e.clientY - rect.top) / rect.height) * 100);
			let left = Math.round(((e.clientX - rect.left) / rect.width) * 100);

			// Maximum number
			let max = this.markers.length
				? this.markers
					.map(m => m.no)
					.sort((a, b) => a - b)
					.pop()
				: 0

			// Saving
			this.markers.push({ top, left, no: max + 1 })
			this.syncToLocalStorage()
		}
	}
}
</script>

<style scoped>
	.image-marker {
		padding: 2rem;
		background-color: #313131;
		min-height: 100vh;
	}
	.image-marker__img {
		position: relative;
		overflow: hidden;
	}
	.image-marker__img img {
		width: 100%;
	}
	.image-marker__marker {
		position: absolute;
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background-color: transparent;
		border: 3px solid red;
	}
	.image-marker__marker > span {
		font-size: 12px;
		color: white;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		pointer-events: none;
	}
</style>